import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO = ({ title, description, keywords }) => {
  const location = useLocation();
  const currentUrl = `https://moironix.com${location.pathname}`;

  return (
    <Helmet key={title + description + keywords}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={currentUrl} />
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
};

export default SEO;
